import React from 'react';
import { formatCurrency } from '../utils/formatCurrency';
import './PatientARClaimsTable.css';

// A patient's outstanding claims, as the A/R tab lists them. Shared so the
// Appointments page's balance click-through shows exactly the same table. With
// `onToggle`, each row carries a checkbox for a claim list (the A/R page's
// "Create list" / "Add to list…"); without it the table is unchanged.
function PatientARClaimsTable({ claims, selectedIds, onToggle }) {
  const selectable = typeof onToggle === 'function';
  return (
    <table className="ar-detail-table">
      <thead>
        <tr>
          {selectable && <th className="col-checkbox" aria-label="Select for a list" />}
          <th>Date of Service</th>
          <th className="col-currency">Billed</th>
          <th className="col-currency">Allowed</th>
          <th className="col-currency">Adjustment</th>
          <th className="col-currency">Ins Paid</th>
          <th className="col-currency">Pt Paid</th>
          <th className="col-currency">Balance</th>
        </tr>
      </thead>
      <tbody>
        {claims.map(claim => (
          <tr key={claim.id}>
            {selectable && (
              <td className="col-checkbox">
                <input
                  type="checkbox"
                  aria-label="Select for a list"
                  checked={Boolean(selectedIds && selectedIds.has(claim.id))}
                  onChange={() => onToggle(claim.id)}
                  disabled={!claim.id}
                />
              </td>
            )}
            <td>{claim.date_of_service || '-'}</td>
            <td className="col-currency">{formatCurrency(claim.billed_amount)}</td>
            <td className="col-currency">{formatCurrency(claim.allowed_amount)}</td>
            <td className="col-currency">{formatCurrency(claim.adjustment_amount)}</td>
            <td className="col-currency">{formatCurrency(claim.insurance_paid)}</td>
            <td className="col-currency">{formatCurrency(claim.patient_payment)}</td>
            <td className="col-currency col-outstanding">{formatCurrency(claim.remaining_balance)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default PatientARClaimsTable;
